// Spanish Language Pack
export default {
  // 检测部位
  part: {
    '车头': 'Parte delantera',
    '发动机舱': 'Compartimento del motor',
    '左前车身': 'Carrocería delantera izquierda',
    '左前内饰': 'Interior delantero izquierdo',
    '左后车身': 'Carrocería trasera izquierda',
    '左后内饰': 'Interior trasero izquierdo',
    '车尾': 'Parte trasera',
    '后备箱内部': 'Interior del maletero',
    '右后车身': 'Carrocería trasera derecha',
    '右后内饰': 'Interior trasero derecho',
    '右前车身': 'Carrocería delantera derecha',
    '右前内饰': 'Interior delantero derecho',
    '机电': 'Electromecánica',
    '新能源检测': 'Inspección de vehículos de nueva energía',
    '骨架': 'Estructura',
    '外观': 'Exterior',
    '内饰': 'Interior',
    '其它': 'Otros',
    '其他': 'Otros',
    '水渍残留点': 'Manchas de agua',
  },

  // 损伤等级颜色
  damageLevel: {
    '轻微损伤': 'Daño leve',
    '严重损伤': 'Daño grave',
    '预检异常': 'Anomalía de preinspección',
  },

  // 评分说明
  scoreRemark: {
    '车辆结构件与加强件均无因事故造成的损伤': 'Sin daños por accidente en los elementos estructurales y de refuerzo del vehículo.',
    '车辆结构件无因事故造成的损伤，车辆加强件有因事故造成的轻微损伤': 'Elementos estructurales sin daños por accidente; daños leves por accidente en los elementos de refuerzo.',
    '车辆结构件无因事故造成的损伤，车辆加强件有因事故造成的严重损伤': 'Elementos estructurales sin daños por accidente; daños graves por accidente en los elementos de refuerzo.',
    '车辆结构件有因事故造成的损伤': 'Daños por accidente en los elementos estructurales.',
    '外观极差': 'Estado exterior extremadamente malo',
    '内饰极差': 'Estado interior extremadamente malo',
    '外观较差': 'Estado exterior malo',
    '内饰较差': 'Estado interior malo',
    '外观一般': 'Estado exterior regular',
    '内饰一般': 'Estado interior regular',
    '外观较好': 'Estado exterior bueno',
    '内饰较好': 'Estado interior bueno',
    '外观准新': 'Estado exterior casi nuevo',
    '内饰准新': 'Estado interior casi nuevo',
  },

  // 检测项名称
  inspectionItem: {
    '左前大灯': 'Farola delantera izquierda',
    '左前雾灯': 'Antiniebla delantero izquierdo',
    '前底盘': 'Bajos delanteros',
    '前保险杠': 'Parachoques delantero',
    '中网': 'Rejilla',
    '发动机舱盖外侧': 'Lado exterior del capó',
    '发动机舱盖内侧': 'Lado interior del capó',
    '水箱框架': 'Marco del radiador',
    '前防撞梁': 'Viga del parachoques delantero',
    '左前纵梁': 'Larguero delantero izquierdo',
    '左前翼子板骨架': 'Guardabarros interior delantero izquierdo',
    '左前减震器支座': 'Torreta del amortiguador delantero izquierdo',
    '防火墙': 'Tabique cortafuegos',
    '车架号': 'Número de chasis (VIN)',
    '右前减震器支座': 'Torreta del amortiguador delantero derecho',
    '右前翼子板骨架': 'Guardabarros interior delantero derecho',
    '右前纵梁': 'Larguero delantero derecho',
    '发动机变速箱及附件': 'Motor, caja de cambios y accesorios',
    '机油': 'Aceite del motor',
    '防冻液': 'Líquido refrigerante',
    '刹车油': 'Líquido de frenos',
    '电池': 'Batería',
    '皮带': 'Correa',
    '保险丝盒': 'Caja de fusibles',
    '发动机线束': 'Arnés del motor',
    '左前轮胎': 'Neumático delantero izquierdo',
    '左前轮毂': 'Llantas delanteras izquierdas',
    '左前避震器': 'Amortiguador delantero izquierdo',
    '左前轮内衬罩': 'Guardabarros interior del pasaje de rueda delantero izquierdo',
    '左前翼子板': 'Aleta delantera izquierda',
    '左后视镜': 'Espejo lateral izquierdo',
    '前风挡玻璃': 'Parabrisas delantero',
    '左A柱外侧': 'Pilar A izquierdo exterior',
    '左前车顶': 'Techo delantero izquierdo',
    '左前门玻璃': 'Vidrio de la puerta delantera izquierda',
    '左前门外侧': 'Panel exterior de la puerta delantera izquierda',
    '左前门裙边外侧': 'Lateral exterior del umbral de la puerta delantera izquierda',
    '左前门内侧': 'Panel interior de la puerta delantera izquierda',
    '左前门内饰（含胶条）': 'Guarnecido de la puerta delantera izquierda (incl. juntas)',
    '左A柱内侧': 'Pilar A izquierdo interior',
    '左前门裙边内侧': 'Lateral interior del umbral de la puerta delantera izquierda',
    '主驾座椅区域': 'Zona del asiento del conductor',
    '主驾座椅滑轨': 'Riel del asiento del conductor',
    '主驾安全带': 'Cinturón de seguridad del conductor',
    '左前地毯（含周边饰条、饰板）': 'Alfombra delantera izquierda (incl. molduras y paneles circundantes)',
    '转向管柱': 'Columna de dirección',
    '方向盘': 'Volante',
    '仪表盘': 'Cuadro de instrumentos',
    '中控台': 'Consola central',
    '前排扶手区域': 'Zona del reposabrazos delantero',
    '主驾仪表台': 'Salpicadero del conductor',
    '左A柱内饰板': 'Guarnecido del pilar A izquierdo',
    '左前顶棚（含前排天窗饰板、遮阳板）': 'Techo delantero izquierdo (incl. guarnecido del techo solar y parasoles)',
    '前排天窗': 'Techo solar delantero',
    '内后视镜区域': 'Zona del espejo retrovisor',
    '左后轮胎': 'Neumático trasero izquierdo',
    '左后轮毂': 'Llanta trasera izquierda',
    '左后避震器': 'Amortiguador trasero izquierdo',
    '左后轮内衬罩': 'Guardabarros interior del pasaje de rueda trasero izquierdo',
    '左后翼子板': 'Aleta trasera izquierda',
    '左C柱外侧': 'Pilar C izquierdo exterior',
    '左后车顶': 'Techo trasero izquierdo',
    '左B柱外侧': 'Pilar B izquierdo exterior',
    '左后门玻璃': 'Vidrio de la puerta trasera izquierda',
    '左后门外侧': 'Panel exterior de la puerta trasera izquierda',
    '左后门裙边外侧': 'Lateral exterior del umbral de la puerta trasera izquierda',
    '左后门内侧': 'Panel interior de la puerta trasera izquierda',
    '左后门内饰（含胶条）': 'Guarnecido de la puerta trasera izquierda (incl. juntas)',
    '左C柱内侧': 'Pilar C izquierdo interior',
    '左B柱内侧': 'Pilar B izquierdo interior',
    '左后门裙边内侧': 'Lateral interior del umbral de la puerta trasera izquierda',
    '左后座椅区域': 'Zona del asiento trasero izquierdo',
    '左后座椅滑轨': 'Riel del asiento trasero izquierdo',
    '左后安全带': 'Cinturón de seguridad trasero izquierdo',
    '左后地毯（含周边饰条、饰板）': 'Alfombra trasera izquierda (incl. molduras y paneles circundantes)',
    '后排扶手区域': 'Zona del reposabrazos trasero',
    '左B柱内饰板': 'Guarnecido del pilar B izquierdo',
    '左C柱内饰板': 'Guarnecido del pilar C izquierdo',
    '左后顶棚（含后排天窗饰板）': 'Techo trasero izquierdo (incl. guarnecido del techo solar trasero)',
    '后排天窗': 'Techo solar trasero',
    '后风挡玻璃': 'Luna trasera',
    '左D柱外侧': 'Pilar D izquierdo exterior',
    '右D柱外侧': 'Pilar D derecho exterior',
    '后备箱盖外侧': 'Lado exterior de la tapa del maletero',
    '左后尾灯': 'Piloto trasero izquierdo',
    '右后尾灯': 'Piloto trasero derecho',
    '后保险杠': 'Parachoques trasero',
    '后防撞梁': 'Viga del parachoques trasero',
    '左后纵梁': 'Larguero trasero izquierdo',
    '右后纵梁': 'Larguero trasero derecho',
    '后底盘': 'Bajos traseros',
    '后备箱盖内侧': 'Lado interior de la tapa del maletero',
    '后备箱盖内饰板（含胶条）': 'Guarnecido de la tapa del maletero (incl. juntas)',
    '后部导水槽': 'Canal de desagüe trasero',
    '左D柱内饰板': 'Guarnecido del pilar D izquierdo',
    '左D柱内侧': 'Pilar D izquierdo interior',
    '右D柱内饰板': 'Guarnecido del pilar D derecho',
    '右D柱内侧': 'Pilar D derecho interior',
    '后窗台板': 'Bandeja trasera',
    '后备箱内饰（含胶条、地毯、周边饰条、饰板）': 'Guarnecido del maletero (incl. juntas, alfombra y molduras circundantes)',
    '后围板': 'Panel trasero',
    '备胎轮胎': 'Rueda de repuesto',
    '备胎轮毂': 'Llanta de repuesto',
    '工具': 'Herramientas',
    '后备箱底板': 'Suelo del maletero',
    '左后翼子板骨架(包含减震器支座)': 'Guardabarros interior trasero izquierdo (incl. torreta del amortiguador)',
    '右后翼子板骨架(包含减震器支座)': 'Guardabarros interior trasero derecho (incl. torreta del amortiguador)',
    '右后轮胎': 'Neumático trasero derecho',
    '右后轮毂': 'Llanta trasera derecha',
    '右后避震器': 'Amortiguador trasero derecho',
    '右后轮内衬罩': 'Guardabarros interior del pasaje de rueda trasero derecho',
    '右后翼子板': 'Aleta trasera derecha',
    '右C柱外侧': 'Pilar C derecho exterior',
    '右后车顶': 'Techo trasero derecho',
    '右B柱外侧': 'Pilar B derecho exterior',
    '右后门玻璃': 'Vidrio de la puerta trasera derecha',
    '右后门外侧': 'Panel exterior de la puerta trasera derecha',
    '右后门裙边外侧': 'Lateral exterior del umbral de la puerta trasera derecha',
    '右后门内侧': 'Panel interior de la puerta trasera derecha',
    '右后门内饰（含胶条）': 'Guarnecido de la puerta trasera derecha (incl. juntas)',
    '右C柱内侧': 'Pilar C derecho interior',
    '右B柱内侧': 'Pilar B derecho interior',
    '右后门裙边内侧': 'Lateral interior del umbral de la puerta trasera derecha',
    '右后座椅区域': 'Zona del asiento trasero derecho',
    '右后座椅滑轨': 'Riel del asiento trasero derecho',
    '右后安全带': 'Cinturón de seguridad trasero derecho',
    '右后地毯（含周边饰条、饰板）': 'Alfombra trasera derecha (incl. molduras y paneles circundantes)',
    '右B柱内饰板': 'Guarnecido del pilar B derecho',
    '右C柱内饰板': 'Guarnecido del pilar C derecho',
    '右后顶棚': 'Techo trasero derecho',
    '右A柱外侧': 'Pilar A derecho exterior',
    '右前车顶': 'Techo delantero derecho',
    '右前门玻璃': 'Vidrio de la puerta delantera derecha',
    '右前门外侧': 'Panel exterior de la puerta delantera derecha',
    '右前门裙边外侧': 'Lateral exterior del umbral de la puerta delantera derecha',
    '右前门内侧': 'Panel interior de la puerta delantera derecha',
    '右前门内饰（含胶条）': 'Guarnecido de la puerta delantera derecha (incl. juntas)',
    '右A柱内侧': 'Pilar A derecho interior',
    '右前门裙边内侧': 'Lateral interior del umbral de la puerta delantera derecha',
    '副驾座椅区域': 'Zona del asiento del acompañante',
    '副驾座椅滑轨': 'Riel del asiento del acompañante',
    '副驾安全带': 'Cinturón de seguridad del acompañante',
    '右前地毯（含周边饰条、饰板）': 'Alfombra delantera derecha (incl. molduras y paneles circundantes)',
    '副驾仪表台': 'Salpicadero del acompañante',
    '右A柱内饰板': 'Guarnecido del pilar A derecho',
    '杂物箱': 'Guantera',
    '右前顶棚（含前排天窗饰板、遮阳板）': 'Techo delantero derecho (incl. guarnecido del techo solar y parasoles)',
    '右前轮胎': 'Neumático delantero derecho',
    '右前轮毂': 'Llanta delantera derecha',
    '右前避震器': 'Amortiguador delantero derecho',
    '右前轮内衬罩': 'Guardabarros interior del pasaje de rueda delantero derecho',
    '右前翼子板': 'Aleta delantera derecha',
    '右后视镜': 'Espejo lateral derecho',
    '右前大灯': 'Farola delantera derecha',
    '右前雾灯': 'Antiniebla delantero derecho',
    '启动': 'Arranque',
    '变速箱': 'Caja de cambios',
    '排烟': 'Humo de escape',
    '无钥匙进入': 'Entrada sin llave',
    '仪表盘功能自检': 'Autocomprobación del cuadro de instrumentos',
    '转向助力': 'Dirección asistida',
    '电动后视镜功能': 'Función de espejos eléctricos',
    '中控锁': 'Cierre centralizado',
    '电动吸合门': 'Puertas de cierre asistido',
    '电动座椅': 'Asientos eléctricos',
    '座椅记忆': 'Memoria del asiento',
    '座椅加热': 'Calefacción de asientos',
    '座椅通风': 'Ventilación de asientos',
    '座椅按摩': 'Masaje de asientos',
    '主驾驶电动门窗总控': 'Control maestro de elevalunas del conductor',
    '灯光系统': 'Sistema de iluminación',
    '前驻车雷达': 'Sensores de aparcamiento delanteros',
    '后驻车雷达': 'Sensores de aparcamiento traseros',
    '倒车影像': 'Cámara de marcha atrás',
    '全景摄像头': 'Cámara panorámica',
    '可变悬架': 'Suspensión adaptativa',
    '车载冰箱': 'Frigorífico de a bordo',
    '室内灯': 'Luces interiores',
    '天窗': 'Techo solar',
    '雨刷': 'Limpiaparabrisas',
    '多功能方向盘': 'Volante multifunción',
    '方向盘换挡拨片': 'Levas de cambio en el volante',
    '方向盘加热': 'Volante calefactable',
    '方向盘记忆': 'Memoria del volante',
    '空调': 'Aire acondicionado',
    '电动门': 'Puertas eléctricas',
    '电动车窗': 'Elevalunas eléctricos',
    '后排电动遮阳帘': 'Cortinilla eléctrica trasera',
    '后排液晶屏': 'Pantalla LCD trasera',
    '玻璃顶电动饰板': 'Guarnecido eléctrico del techo de cristal',
    '硬顶敞篷': 'Descapotable de techo rígido',
    '发动机': 'Motor',
    '多媒体系统': 'Sistema multimedia',
    '动力电池包安装点': 'Puntos de fijación del paquete de baterías de tracción',
    '动力电池包': 'Paquete de baterías de tracción',
    '驱动电机(可见部分)': 'Motor de tracción (parte visible)',
    '逆变器(可见部分)': 'Inversor (parte visible)',
    '车身高压线束(可见部分)': 'Arnés de alta tensión de la carrocería (parte visible)',
    '随车充电枪': 'Cargador portátil',
    '车辆充电口': 'Puerto de carga del vehículo',
    '增程器': 'Extensor de autonomía',
    '动力系统故障码': 'Código de avería del tren motriz',
    '车辆充电故障': 'Avería de carga del vehículo',
  },

  // 缺陷名称
  defect: {
    '安装不良': 'Instalación deficiente',
    '常转': 'Funcionamiento continuo',
    '超出上限': 'Por encima del límite superior',
    '闯档': 'Enganche brusco de marcha',
    '篡改': 'Manipulación',
    '打齿异响': 'Ruido de engrane de dientes',
    '打滑': 'Patinaje',
    '打磨': 'Pulido',
    '灯内异物': 'Cuerpo extraño en el faro',
    '低于下限': 'Por debajo del límite inferior',
    '断裂': 'Fractura',
    '钣金修复': 'Reparación de chapa',
    '改装': 'Modificación',
    '更换': 'Sustitución',
    '功能失效': 'Sin funcionamiento',
    '鼓包': 'Abombamiento',
    '故障': 'Avería',
    '后打胶': 'Resellado trasero',
    '花屏': 'Distorsión de pantalla',
    '划痕': 'Rayadura',
    '划伤': 'Arañazo',
    '晃动': 'Juego / balanceo',
    '变形': 'Deformación',
    '浑浊': 'Fluido turbio',
    '胶套损坏': 'Fuelle dañado',
    '胶体异常': 'Masilla anómala',
    '胶条异常': 'Junta anómala',
    '卡滞': 'Atascamiento',
    '空转': 'Giro en vacío',
    '老化': 'Envejecimiento',
    '裂纹': 'Grieta',
    '冒白烟': 'Humo blanco',
    '冒黑烟': 'Humo negro',
    '不出风': 'Sin salida de aire',
    '冒蓝烟': 'Humo azul',
    '霉斑': 'Manchas de moho',
    '磨损': 'Desgaste',
    '泥沙': 'Barro y sedimentos',
    '喷漆': 'Repintado',
    '偏磨': 'Desgaste desigual',
    '破裂': 'Rotura',
    '破损': 'Daño',
    '启动困难': 'Arranque difícil',
    '气囊爆裂': 'Despliegue del airbag',
    '不跳档': 'No cambia de marcha',
    '切割': 'Corte',
    '缺失': 'Pieza ausente',
    '缺损': 'Falta de material',
    '缺线': 'Cableado ausente',
    '入档困难': 'Enganche de marcha difícil',
    '色差': 'Diferencia de color',
    '烧烫': 'Quemadura',
    '渗水': 'Filtración de agua',
    '渗油': 'Resudado de aceite',
    '失效': 'Fuera de servicio',
    '不制冷': 'No enfría',
    '水雾': 'Vaho',
    '松动': 'Aflojamiento',
    '松旷': 'Juego excesivo',
    '损坏': 'Rotura parcial',
    '损伤': 'Zona dañada',
    '塌陷': 'Hundimiento',
    '调节失效': 'Fallo de ajuste',
    '贴膜起泡': 'Burbujas en la lámina',
    '脱档': 'Salto de marcha',
    '污渍': 'Manchas',
    '不走车': 'El vehículo no avanza',
    '响应慢': 'Respuesta lenta',
    '修复': 'Reparación',
    '锈蚀': 'Corrosión',
    '异味': 'Olor',
    '异响': 'Ruido anómalo',
    '怠速不稳': 'Ralentí inestable',
    '怠速过高': 'Ralentí elevado',
    '给不上油': 'Sin suministro de combustible',
    '加速抖动': 'Temblor al acelerar',
    '缺缸': 'Fallo de cilindro',
    '部件缺失': 'Piezas ausentes',
    '气门异响': 'Ruido de válvulas',
    '内部异响': 'Ruido interno',
    '轮组异响': 'Ruido del conjunto de rueda',
    '窜气': 'Paso de gases (blow-by)',
    '排气异响': 'Ruido de escape',
    '水渍': 'Mancha de agua',
    '凹陷': 'Abolladura',
    '车门更换': 'Puerta sustituida',
    '拆卸': 'Desmontaje',
    '后盖更换': 'Tapa del maletero sustituida',
    '机盖更换': 'Capó sustituido',
    '内饰更换': 'Interior sustituido',
    '焊接': 'Soldadura',
    '开裂': 'Agrietamiento',
    '剐蹭划伤': 'Rozaduras y rayaduras',
    '渗漏': 'Fuga',
    '火烧': 'Quemadura por incendio',
    '抖动': 'Temblor',
    '动力电池故障': 'Avería del paquete de baterías de tracción',
    '驱动电机故障': 'Avería del motor de tracción',
    '其他': 'Otros',
    '快充故障': 'Avería de carga rápida',
    '慢充故障': 'Avería de carga lenta',
    '过火': 'Rastros de fuego',
    '缺气': 'Presión de aire insuficiente',
  },

  // 等级
  grade: {
    'A': 'Grado A',
    'B': 'Grado B',
    'C': 'Grado C',
    'D': 'Grado D',
  },

  // 综合描述模板关键词
  description: {
    '外观无换件': 'Sin piezas exteriores sustituidas',
    '外观原漆': 'Pintura original',
    '外观无需整备成本': 'Sin coste de acondicionamiento exterior',
    '内饰正常使用痕迹': 'Desgaste normal del interior',
    '车辆无骨架损伤': 'Sin daños en la estructura',
    '发动机工况无异常': 'Estado del motor normal',
    '变速器原地试车无异常': 'Prueba estática de la transmisión normal',
  },

  // 通用
  common: {
    '项': 'elementos',
    '项异常': 'elementos anómalos',
    '分': 'pts',
    '级': 'Grado',
    '检测': 'Inspección',
    '图片': 'Imagen',
    '加载失败': 'Error de carga',
    '加载中...': 'Cargando...',
  },

  // 页面标题
  title: {
    '车况检测': 'Inspección del estado del vehículo',
    '综合描述': 'Descripción general',
    '综合': 'General',
  },

  // 提示文案
  tips: {
    '源于出险数据': '(Según datos de siniestros)',
    '车辆是否曾进水(漏水/涉水/水泡)': '¿El vehículo ha estado expuesto al agua (fuga/vadeo/inundación)?',
    '是': 'Sí',
    '否': 'No',
    '查看原图': 'Ver imagen original',
  },

  // 评分规则标题
  ruleTitle: {
    '外观评分规则': 'Reglas de puntuación del exterior',
    '骨架评级规则': 'Reglas de evaluación de la estructura',
    '内饰评分规则': 'Reglas de puntuación del interior',
    '综合评级规则': 'Reglas de evaluación general',
  },

  // 外观评分说明
  exteriorRule: {
    '外观准新': 'Estado exterior casi nuevo',
    '外观较好': 'Estado exterior bueno',
    '外观一般': 'Estado exterior regular',
    '外观较差': 'Estado exterior malo',
    '外观极差': 'Estado exterior extremadamente malo',
  },

  // 内饰评分说明
  interiorRule: {
    '内饰准新': 'Estado interior casi nuevo',
    '内饰较好': 'Estado interior bueno',
    '内饰一般': 'Estado interior regular',
    '内饰较差': 'Estado interior malo',
    '内饰极差': 'Estado interior extremadamente malo',
  },

  // 骨架评级说明
  skeletonRule: {
    '车辆结构件与加强件均无因事故造成的损伤': 'Sin daños por accidente en los elementos estructurales y de refuerzo del vehículo.',
    '车辆结构件无因事故造成的损伤，车辆加强件有因事故造成的轻微损伤': 'Elementos estructurales sin daños por accidente; daños leves por accidente en los elementos de refuerzo.',
    '车辆结构件无因事故造成的损伤，车辆加强件有因事故造成的严重损伤': 'Elementos estructurales sin daños por accidente; daños graves por accidente en los elementos de refuerzo.',
    '车辆结构件有因事故造成的损伤': 'Daños por accidente en los elementos estructurales.',
  },

  // 综合评级说明
  overallRule: {
    '骨架等级≥A，外观评分≥90，内饰评分≥90，不可出现更换，切割，锈蚀，泥沙，水渍，部件缺失，霉斑，烧烫和机电模块损伤。': 'Estructura grado ≥A, puntuación exterior ≥90, puntuación interior ≥90; no se permiten reemplazos, cortes, óxido, barro, manchas de agua, piezas faltantes, moho, quemaduras ni daños en módulos electromecánicos.',
    '骨架等级≥A，外观评分≥80，内饰评分≥80，不可出现切割，泥沙，水渍，霉斑，锈蚀等损伤。': 'Estructura grado ≥A, puntuación exterior ≥80, puntuación interior ≥80; no se permiten cortes, barro, manchas de agua, moho, óxido, etc.',
    '骨架等级≥B，外观评分＞40，内饰评分＞40': 'Estructura grado ≥B, puntuación exterior >40, puntuación interior >40',
    '骨架等级≥C，外观评分≥70，内饰评分≥70': 'Estructura grado ≥C, puntuación exterior ≥70, puntuación interior ≥70',
    '骨架等级≥D，外观评分≥60，内饰评分≥50': 'Estructura grado ≥D, puntuación exterior ≥60, puntuación interior ≥50',
    '骨架等级≥D，外观评分≥50，内饰评分≥40，不可勾选水泡车。': 'Estructura grado ≥D, puntuación exterior ≥50, puntuación interior ≥40; no se permite marcar vehículo inundado.',
    '骨架等级≥D，外观评分<50，内饰评分<40': 'Estructura grado ≥D, puntuación exterior <50, puntuación interior <40',
  }
}
